import { createSlice } from "@reduxjs/toolkit";
// import getSuperadminDetailsApi from "@custom/rtk-apis/masterSuperAdminProfile/getSuperadminDetails";
import getCreditsPerGbApi from "@custom/rtk-apis/masterSuperAdminProfile/getCreditsPerGb";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const getCreditPerGbDetailsSlice = createSlice({
  name: "getCreditPerGbDetailsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCreditsPerGbApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(getCreditsPerGbApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getCreditsPerGbApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getCreditPerGbDetailsSlice.reducer;
